import { downloadBlob } from "../download-blob";
import { scheduleDocument } from "./schedule-json";
import { useScheduleStore } from "../../stores/schedule-store";

export function downloadSchedule() {
  const data = scheduleDocument(useScheduleStore.getState());
  const blob = new Blob([JSON.stringify(data, null, 2) + "\n"], { type: "application/json" });
  downloadBlob(blob, `schedule-${data.selectedDate}.json`);
}
